import { css } from "styled-components";
import { Toast } from "drywall";
import token from "styled-token";
import { statusDialogMixin } from "../statusDialogMixin";
/** @class ToastMixin */

/** @method */

export var ToastMixin = function ToastMixin(props) {
  return token({
    maxWidth: "Toast.maxWidth",
    borderRadius: "radii.md",
    boxShadow: "Dialog.boxShadow"
  }, function (_ref) {
    var maxWidth = _ref.maxWidth,
        borderRadius = _ref.borderRadius,
        boxShadow = _ref.boxShadow;
    return css(["", " display:inline-flex;max-width:", "px;border-radius:", "px;box-shadow:", ";", "{flex-shrink:1;}"], statusDialogMixin(Object.assign({
      inverse: true
    }, props)), maxWidth, borderRadius, boxShadow, Toast.Body);
  })(props);
};